import React from 'react';
import { ArrowRight, Leaf, Package, Truck } from 'lucide-react';
import { BRAND } from '../mock/mock';

export default function HeroBanner() {
  return (
    <section className="hero-radial">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <span className="chip" style={{ background: 'rgba(201,169,97,0.18)', color: 'var(--gk-gold-dark)' }}>
            <Leaf size={12} /> Farm to Kitchen · Handpicked
          </span>
          <h1 className="font-serif mt-5 text-4xl md:text-6xl leading-[1.05] font-bold" style={{ color: 'var(--gk-green-dark)' }}>
            Journey to <span style={{ color: 'var(--gk-terracotta)' }}>Your Gaon.</span><br />
            One Masala at a Time.
          </h1>
          <p className="mt-5 text-base md:text-lg max-w-lg" style={{ color: 'var(--gk-muted)' }}>
            Freshly ground spices and traditional masala blends, brought directly from Indian farms to your kitchen — no chemicals, no fillers, only the honest taste of a village kitchen.
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href="#all" className="gk-btn-primary">
              Shop All Spices <ArrowRight size={16} />
            </a>
            <a href="#story" className="gk-btn-outline">Our Story</a>
          </div>

          <div className="mt-8 inline-flex items-center gap-4 p-4 rounded-xl" style={{ background: 'rgba(255,255,255,0.7)', border: '1px dashed var(--gk-gold)' }}>
            <div className="font-serif text-2xl md:text-3xl font-bold" style={{ color: 'var(--gk-terracotta)' }}>15% OFF</div>
            <div className="text-sm leading-tight" style={{ color: 'var(--gk-ink)' }}>
              on orders above <strong>₹1,500</strong><br />
              <span style={{ color: 'var(--gk-muted)' }}>Use code</span> <strong style={{ color: 'var(--gk-green-dark)' }}>GAON15</strong>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute -top-6 -right-6 w-40 h-40 rounded-full blur-3xl opacity-40" style={{ background: 'var(--gk-gold)' }} />
          <div className="absolute -bottom-8 -left-8 w-48 h-48 rounded-full blur-3xl opacity-30" style={{ background: 'var(--gk-green-light)' }} />

          {/* Main logo centerpiece */}
          <div className="relative flex items-center justify-center">
            <div className="absolute w-[380px] h-[380px] md:w-[480px] md:h-[480px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(201,169,97,0.25) 0%, transparent 65%)' }} />
            <img
              src={BRAND.logo}
              alt="Gaon Ke Masale — official brand logo"
              className="relative w-[300px] md:w-[440px] h-[300px] md:h-[440px] rounded-full object-cover shadow-2xl"
              style={{ boxShadow: '0 30px 60px -20px rgba(63,82,37,0.5), 0 0 0 6px rgba(255,255,255,0.6), 0 0 0 8px rgba(201,169,97,0.5)' }}
            />

            {/* Floating spice pouch preview */}
            <img
              src={BRAND.pouches}
              alt="Gaon Ke Masale spice pouches"
              className="hidden md:block absolute -bottom-4 -right-4 w-40 h-40 rounded-2xl object-cover shadow-xl ring-4 ring-white"
            />
          </div>

          <div className="absolute -bottom-2 left-6 md:left-10 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-3 flex items-center gap-3 shadow-lg">
            <Package size={20} style={{ color: 'var(--gk-terracotta)' }} />
            <div className="text-xs" style={{ color: 'var(--gk-ink)' }}>
              <div className="font-bold">Heritage Experience Box</div>
              <div style={{ color: 'var(--gk-muted)' }}>Now shipping pan India</div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature strip */}
      <div className="border-y" style={{ borderColor: '#ecdfc7', background: 'rgba(255,255,255,0.6)' }}>
        <div className="max-w-[1400px] mx-auto px-6 py-5 grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          {[
            { icon: Leaf, label: '100% Natural', sub: 'No preservatives' },
            { icon: Package, label: 'Small-batch', sub: 'Freshly packed' },
            { icon: Truck, label: 'Free Shipping', sub: 'Orders above ₹499' },
            { icon: ArrowRight, label: 'Farm Direct', sub: 'From Indian villages' },
          ].map((f, i) => (
            <div key={i} className="flex items-center justify-center gap-3">
              <f.icon size={20} style={{ color: 'var(--gk-green)' }} />
              <div className="text-left">
                <div className="text-sm font-semibold" style={{ color: 'var(--gk-ink)' }}>{f.label}</div>
                <div className="text-xs" style={{ color: 'var(--gk-muted)' }}>{f.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
